import React from 'react';
import { PRINT_COLORS } from '../../qaqc/reports/printTheme';

const PrintCoverPage = ({ reportDateLabel, campaignLabel, reportTitle = 'SCMI Daily Report' }) => (
  <div
    style={{
      width: '100%',
      maxWidth: '1000px',
      minHeight: '380px',
      padding: '48px 32px',
      background: 'linear-gradient(135deg, #0f766e 0%, #134e4a 100%)',
      color: '#ffffff',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    }}
  >
    <div style={{ fontSize: '14px', letterSpacing: '0.15em', opacity: 0.85, marginBottom: '24px' }}>
      SELKIRK COPPER MINES
    </div>
    <h1 style={{ fontSize: '32px', fontWeight: 'bold', margin: '0 0 16px 0' }}>{reportTitle}</h1>
    {reportDateLabel && (
      <div style={{ fontSize: '20px', marginBottom: '12px', color: '#ccfbf1' }}>{reportDateLabel}</div>
    )}
    {campaignLabel && (
      <div style={{ fontSize: '14px', opacity: 0.9 }}>{campaignLabel}</div>
    )}
    <div
      style={{
        marginTop: '48px',
        paddingTop: '24px',
        borderTop: `1px solid ${PRINT_COLORS.border}`,
        width: '60%',
        fontSize: '11px',
        color: 'rgba(255,255,255,0.7)',
      }}
    >
      Generated {new Date().toLocaleString()}
    </div>
  </div>
);

export default PrintCoverPage;
